import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-xl bg-intri-raised px-4 text-sm text-intri-text",
          "border border-intri-border",
          "placeholder:text-intri-muted",
          "transition-colors duration-200",
          "focus:outline-none focus:border-intri-accent/50 focus:ring-1 focus:ring-intri-accent/20",
          "disabled:cursor-not-allowed disabled:opacity-40",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";
